import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  Text,
  Textarea,
  FormErrorMessage,
  useToast,
  Stack,
  Box,
  CheckboxGroup,
  Checkbox,
} from "@chakra-ui/core";
import React from "react";
import { Layout } from "../layouts/Layout";
import { useForm } from "react-hook-form";
import jwtService from "../api/jwt.service";
import { useHistory } from "react-router";
import { updateMentorProfile } from "../api/mentor.service";

const MentorEdit = () => {
  const { register, errors, formState, handleSubmit } = useForm();
  const history = useHistory();

  const user = JSON.parse(jwtService.getItem("user"));
  const [expertise, setExpertise] = React.useState([]);

  const onSubmitHandler = async (values) => {
    try {
      const { data } = await updateMentorProfile({
        ...values,
        expertise: JSON.stringify(expertise),
      });
      data?.mentor && history.push("/dashboard");
    } catch (error) {}
  };

  return (
    <Layout title="GrEEn | Mentor Update">
      <Box my={["160px", "200px"]}>
        <Text
          textAlign="center"
          fontSize={["xl", "3xl"]}
          fontWeight="700"
          fontFamily="Familiar Pro"
        >
          Application/ Profiling form for Green Business Mentors
        </Text>
        <Box w={["95%", "80%"]} shadow="lg" p={["8", "20"]} mx="auto" mt="8">
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <Flex direction={["column", "row"]}>
              <FormControl mb="6" mr={["0", "2"]} flex="1" isRequired>
                <FormLabel htmlFor="nationality" isInvalid={errors.nationality}>
                  Nationality
                </FormLabel>
                <Input type="text" name="nationality" ref={register}></Input>
                <FormErrorMessage>
                  {errors.nationality && errors.nationality.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl mb="6" mr={["0", "2"]} flex="1" isRequired>
                <FormLabel htmlFor="title" isInvalid={errors.title}>
                  Title
                </FormLabel>
                <Input
                  type="text"
                  placeholder="Title (Mr/Ms/Dr/Prof)"
                  name="title"
                  ref={register({ required: "Field is required" })}
                ></Input>
                <FormErrorMessage>
                  {errors.title && errors.title.message}
                </FormErrorMessage>
              </FormControl>
            </Flex>

            <FormControl
              mb="6"
              flex="1"
              isRequired
              isInvalid={errors.biography}
              mr={["0", "2"]}
            >
              <FormLabel htmlFor="biography">Biography</FormLabel>
              <Box bg="green.50" padding="4" my="2">
                <Text fontSize="14px">
                  Please attach a short biography which can be used in the
                  process of matching you with a green business start-up.
                  (Please note no more than 1-2 pages- not a detailed CV, but a
                  short outline of your key experiences/ roles/ research etc)
                </Text>
              </Box>
              <Textarea
                placeholder=""
                name="biography"
                ref={register}
              ></Textarea>
              <FormErrorMessage>
                {errors.biography && errors.biography.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb="6" isInvalid={errors.residential_address} flex="1">
              <FormLabel htmlFor="residential_address">
                Residential Address
              </FormLabel>
              <Input
                type="text"
                placeholder="Residential Address"
                name="residential_address"
                ref={register}
              ></Input>
              <FormErrorMessage>
                {errors.residential_address &&
                  errors.residential_address.message}
              </FormErrorMessage>
            </FormControl>

            <FormControl mb="6" isInvalid={errors.expertise} flex="1">
              <FormLabel htmlFor="expertise">Expertise</FormLabel>
              <Box bg="green.50" padding="4" my="2">
                <Text fontSize="14px">
                  Sectors of expertise (Please tick if applicable)
                </Text>
              </Box>
              {/* Agriculture/Agri-Business  
Water, Sanitation and Hygiene (WASH)
Renewable Energy and Energy Efficiency (REEE)
Circular economy businesses  
Other, Specify */}
              <CheckboxGroup
                colorScheme="green"
                spacing="6"
                name="expertise"
                onChange={(values) => setExpertise(values)}
              >
                <Checkbox value="Agriculture/Agri-Business">
                  Agriculture/Agri-Business
                </Checkbox>
                <Checkbox value="Water, Sanitation and Hygiene (WASH)">
                  Water, Sanitation and Hygiene (WASH)
                </Checkbox>
                <Checkbox value="Circular Economy Businesses">
                  Circular Economy Businesses
                </Checkbox>
                <Checkbox value="Other">Other</Checkbox>
              </CheckboxGroup>

              {expertise.map((expertise) => {
                return (
                  expertise === "Other" && (
                    <Input
                      mt="4"
                      type="text"
                      ref={register}
                      placeholder="Other, Specify"
                      name="expertise"
                    ></Input>
                  )
                );
              })}

              <FormErrorMessage>
                {errors.expertise && errors.expertise.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb="6" isInvalid={errors.motivation} flex="1">
              <FormLabel htmlFor="motivation">Motivation</FormLabel>
              <Box bg="green.50" padding="4" my="2">
                <Text fontSize="14px">
                  What is your motivation for wanting to join the GrEEn project
                  incubation and acceleration mentoring programme?
                </Text>
              </Box>
              <Textarea
                type="text"
                placeholder=""
                name="motivation"
                ref={register}
              ></Textarea>
              <FormErrorMessage>
                {errors.motivation && errors.motivation.message}
              </FormErrorMessage>
            </FormControl>

            <FormControl mb="6" isInvalid={errors.skills} flex="1">
              <FormLabel htmlFor="skills">Skills</FormLabel>
              <Box bg="green.50" padding="4" my="2">
                <Text fontSize="14px">
                  What key skills and experiences would you bring to the
                  mentoring relationship?
                </Text>
              </Box>
              <Textarea
                type="text"
                placeholder=""
                name="skills"
                ref={register}
              ></Textarea>
              <FormErrorMessage>
                {errors.skills && errors.skills.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb="6" isInvalid={errors.experience} flex="1">
              <FormLabel htmlFor="experience">Experience</FormLabel>
              <Box bg="green.50" padding="4" my="2">
                <Text fontSize="14px">
                  Please indicate any previous experiences in formal or informal
                  mentoring programs
                </Text>
              </Box>
              <Textarea
                type="text"
                placeholder=""
                name="experience"
                ref={register}
              ></Textarea>
              <FormErrorMessage>
                {errors.experience && errors.experience.message}
              </FormErrorMessage>
            </FormControl>

            <FormControl mb="6" isInvalid={errors.benefit} flex="1">
              <FormLabel htmlFor="benefit">Benefit</FormLabel>
              <Box bg="green.50" padding="4" my="2">
                <Text fontSize="14px">
                  What benefit might you gain from being a mentor?
                </Text>
              </Box>
              <Textarea
                type="text"
                placeholder=""
                name="benefit"
                ref={register}
              ></Textarea>
              <FormErrorMessage>
                {errors.benefit && errors.benefit.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb="6" isInvalid={errors.research_interests} flex="1">
              <FormLabel htmlFor="research_interests">
                Research Interests
              </FormLabel>
              <Box bg="green.50" padding="4" my="2">
                <Text fontSize="14px">What are your research interests?</Text>
              </Box>
              <Textarea
                type="text"
                placeholder=""
                name="research_interests"
                ref={register}
              ></Textarea>
              <FormErrorMessage>
                {errors.research_interests && errors.research_interests.message}
              </FormErrorMessage>
            </FormControl>

            <Flex justify="space-between" align="flex-end">
              <Button
                type="submit"
                variantColor="green"
                rightIcon="arrow-forward"
                my="4"
                isLoading={formState.isSubmitting}
              >
                Create Profile
              </Button>
            </Flex>
          </form>
        </Box>
      </Box>
    </Layout>
  );
};

export default MentorEdit;
